<app-base-loading-button-modal
  modalTitle="Add Personal Information"
  i18n-modalTitle
  primaryLabel="Next"
  i18n-primaryLabel
  [isLoading]="isLoading$ | async"
  [hideSecondary]="true"
  [ignoreEscape]="true"
  [hideClose]="true"
  (primaryClicked)="submitForm()">
  <ng-container *ngIf="!(isLoading$ | async); else loading">
    <ng-container *ngIf="formGroup$ | async as form">
      <div [formGroup]="form" class="d-flex flex-column" [style.gap.rem]="2">
        <div>
          <div class="form-title" i18n>Personal Information</div>
          <app-member-onboarding-modal-personal-information-form
            [form]="form"
            [formSubmitted]="formSubmitted"
            [pronouns]="pronouns$ | async"
            [genders]="genders$ | async" />
        </div>
        <div class="d-flex gap-2">
          <img
            [ngbTooltip]="tooltip"
            [src]="'assets/icons/grey/CircleQuestion.svg'"
            alt=""
            [style.height.rem]="1.03125"
            [style.width.rem]="1.03125" />
          <div class="tooltip-helper" i18n>Information is incorrect</div>
        </div>
        <hr class="my-0" />
        <div>
          <div class="form-title" i18n>Contact Information</div>
          <app-member-onboarding-modal-contact-information-form
            [form]="form"
            [formSubmitted]="formSubmitted"
            [countries]="countries$ | async" />
        </div>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #loading>
    <div class="form-grid">
      <div *appRepeat="16" class="d-flex flex-column gap-2">
        <lib-loading-shimmer [height]="'1.125rem'" [width]="'3rem'" />
        <lib-loading-shimmer [height]="'3rem'" [width]="'100%'" />
      </div>
    </div>
  </ng-template>
</app-base-loading-button-modal>

<ng-template #tooltip>
  <div class="tooltip-title" i18n>Incorrect Information</div>
  <div class="tooltip-body">
    <ng-container i18n>
      You may request a Name Change or Personal Information Change through the Member Portal once your profile is
      created.
    </ng-container>
  </div>
</ng-template>
